export const Page = {
  dashboard: 'Dashboard',
  loyalty: 'Loyalty Program',
  profiles: 'Profiles',
  companies: 'Companies',
  products: 'Products',
  pushNotifications: 'Push Notifications',
  recommenders: 'Product Blocks',
  banners: 'Banners',
  banner: 'Banner',
  story: 'Story',
  stories: 'Stories',
  bannerBlocks: 'Banner Blocks',
  postPurchases: 'Post Purchases',
  searchAsYouType: 'Search As You Type',
  chatBot: 'Chat Bot',
  agents: 'Agents',
  connectors: 'Connectors',
  campaigns: 'Campaigns',
  facebookAd: 'Facebook Ad',
  facebookAds: 'Facebook Ads',
  workflows: 'Workflows',
  assets: 'Files',
  reports: 'Reports',
  email: 'Emails',
  pushNotification: 'Push Notifications',
  textMessage: 'Text Messages',
  viberMessage: 'Viber Messages',
  segment: 'Segments',
  asset: 'File',
  template: 'Layouts',
  events: 'Events',
  settings: 'Settings',
  newShop: 'New Shop',
  login: 'Login Page',
  confirmPage: 'Confirm Page',
  resetPassword: 'Reset Password',
  resetPasswordSentEmail: 'Reset Password Sent Email',
  resetPasswordConfirm: 'Reset Password Confirm',
  notFoundPage: 'Not Found Page',
  userGuide: 'How-To Guide',
  productFeed: 'Product Feeds',
  facebookProductSet: 'Facebook Product Sets',
  shopifyIntegration: 'Get started with Releva',
  payment: 'Add payment to your account via Stripe',
  plan: 'Select your Releva plan',
  abTests: 'A/B Tests',
  coupon: 'Dynamic Coupons',
  productTrends: 'Product Trends',
  catalogTrigger: 'Catalog Triggers',
  activateDomain: 'Get started with Releva',
  whatsappMessage: 'WhatsApp Messages',
  influencers: 'Influencers',
  meta: 'Facebook & WhatsApp',
  generatedContent: 'Generated Content',
  confirmAccountPage: 'Confirm your Account',
  stripoTemplates: 'Stripo Templates',
  googleAd: 'Google Ad',
  googleAds: 'Google Ads',
  survey: 'Surveys',
  npsSurveys: 'NPS Surveys',
  webhook: 'Webhook',
  syncSegments: 'Sync Segments',
  pipelines: 'Pipelines',
  customerInsights: 'Customer Insights',
  oauthConsent: 'Connect an AI assistant',
  flowProposals: 'AI proposals',
  campaignProposals: 'AI proposals',
};

// Ordered as the funnel runs: reach, engage, convert, earn — then who (User
// Base), how (Marketing) and whether to trust it (Data Quality). Revenue used to
// sit second, before the things that produce it; nothing is renamed, since the
// existing names are what people and the product tour know.
export const DashboardTabs = {
  atAGlance: 'At a Glance',
  traffic: 'Traffic',
  engagement: 'Engagement',
  conversion: 'Conversion',
  revenue: 'Revenue',
  userBase: 'User Base',
  marketing: 'Marketing',
  dataQuality: 'Data Quality',
};

export const CustomerInsightsTabs = {
  rfm: 'RFM Analysis',
  audiencePerformance: 'Audience Performance',
  funnels: 'Funnels',
  cohorts: 'Cohort Analysis',
};

export const CampaignTypes = {
  oneOff: 'One Off',
  continuous: 'Continuous',
  triggered: 'Triggered',
  custom: 'Custom',
};

export const SettingsDomainTabs = {
  general: 'General',
  analytics: 'Events & Analytics',
  productSync: 'Catalog Sync',
  emails: 'Emails',
  viber: 'Viber',
  textMessage: 'Text Message',
  viberMessage: 'Viber Message',
  pushNotification: 'Push Notification',
  webhooks: 'Webhooks',
  whatsapp: 'WhatsApp',

  usage: 'Subscriptions & Usage',
  billing: 'Billing',
  shipmentProvider: 'Shipment Provider',
  feedBandit: 'Feed bandit',
  auditLog: 'Audit Log',
  facebook: 'Facebook',
  tracking: 'Tracking',
  whatsApp: 'WhatsApp',
  google: 'Google Ads',
  aiHubTokens: 'AI Hub Tokens',
  secrets: 'Secrets',
  googleAnalytics: 'Google Analytics',
  tiktok: 'TikTok',
};
export const SettingsAccountTabs = {
  account: 'Account',
  usage: 'Usage',
  collaborators: 'Collaborators',
  connectedApps: 'Connected apps',
};
